__turbopack_context__.v({
  "container": "Textarea-module-scss-module__9OCFmW__container",
  "error": "Textarea-module-scss-module__9OCFmW__error",
  "info": "Textarea-module-scss-module__9OCFmW__info",
  "success": "Textarea-module-scss-module__9OCFmW__success",
  "textarea": "Textarea-module-scss-module__9OCFmW__textarea",
  "warn": "Textarea-module-scss-module__9OCFmW__warn",
  "warning": "Textarea-module-scss-module__9OCFmW__warning",
});
